import { cdnDomain } from '@/config'

export const menuFooter2 = function menuFooter2() {
  const getPdfUrl = (name) => {
    return `${cdnDomain}documents/${this.$i18n.locale}/${name}`
  }
  return [
    {
      label: this.$t(`Imprint`),
      to: `${cdnDomain}Imprint.html`,
    },
    {
      label: this.$t('Privacy Policy'),
      to: getPdfUrl('PrivacyPolicyUF.pdf'),
    },
    {
      label: this.$t('Terms and Conditions'),
      to: getPdfUrl('TermsandConditionsUF.pdf'),
    },
    {
      label: this.$t('Terms of Use'),
      to: getPdfUrl('TermsofUseUF.pdf'),
    },
  ]
}
